import { useContext, useMemo } from 'react';
import UIDContext from './UIDContext';

export default function useUID(suffix: string) {
  const prefixer = useContext(UIDContext);
  return useMemo(() => prefixer(suffix), [suffix, prefixer]);
}
